// Segmented control — 옵션 중 하나를 선택. 클릭 시 active 상태가 내부에서
// 갱신되고 onChange로 외부에 알림. 상태가 단순(active 값 하나)해서 useState로
// 처리. 시간 피커/스테퍼처럼 imperative getValue/setValue를 노출하지 않음.

import { useState } from "preact/hooks";

interface SegmentProps<T> {
  options: Array<[T, string]>;
  initial: T;
  onChange: (val: T) => void;
}

export function Segment<T>({ options, initial, onChange }: SegmentProps<T>) {
  const [active, setActive] = useState<T>(initial);
  return (
    <div class="segment">
      {options.map(([val, label]) => (
        <button
          type="button"
          class={`segment__btn${val === active ? " segment__btn--active" : ""}`}
          onClick={() => {
            setActive(val);
            onChange(val);
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
